import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: '[validation-message]',
	templateUrl: './validation-messages.component.html',
})
export class ValidationMessagesComponent {
	@Input() control: FormControl;

	constructor(private translateService: TranslateService) {}

	onGetErrorMessage(): string | null {
		if (this.control) {
			for (const validatorName in this.control.errors) {
				// eslint-disable-next-line no-prototype-builtins
				if (
					this.control.errors.hasOwnProperty(validatorName) &&
					this.control.touched
				) {
					return this.onGetMessageErrorByValidator({
						validatorName,
						validatorValue: this.control.errors[validatorName],
						labelField: this.control.errors.label,
					});
				}
			}
		}

		return null;
	}

	private onGetMessageErrorByValidator(params: {
		validatorName: string;
		validatorValue: {
			max: string | number;
			min: string | number;
			requiredLength: number;
			message: string;
		};
		labelField: string;
	}): string {
		let config = {};

		this.translateService.get('VALIDATIONS_FORM').subscribe((translated) => {
			config = {
				required: translated['REQUIRED'],
				email: translated['EMAIL'],
				password: translated['PASSWORD'],
				customMessage: params.validatorValue.message,
			};
		});

		return config[params.validatorName];
	}
}
